import { AnimatePresence, motion, Reorder } from 'motion/react'
import React, { useState } from 'react'
import styled from 'styled-components'

import { FavoriteStar } from '@root/features/favorite-pairs/ui/common'

import { TOPBAR_BG_COLOR } from '../constants'
import { TopbarTrendingItem } from '../topbar-trending/topbar-trending-item'

import type { PairModel } from '@root/entities/pair'

type Props = {
  pair: PairModel
  className?: string
}

export const TopbarFavoritesItem = ({ pair, className }: Props) => {
  const [isDrag, setIsDrug] = useState(false)
  const [isHovered, setIsHovered] = useState(false)

  return (
    <Reorder.Item
      onDragStart={() => setIsDrug(true)}
      onDragEnd={() => setIsDrug(false)}
      className={className}
      as="div"
      value={pair.address}
      key={pair.address}
      data-dragging={isDrag}
    >
      <Item
        $isDrag={isDrag}
        onPointerEnter={() => setIsHovered(true)}
        onPointerLeave={() => setIsHovered(false)}
      >
        <TopbarTrendingItem pair={pair} />
        <AnimatePresence initial={false}>
          {isHovered ? (
            <motion.div
              layout
              initial={{ width: 0, opacity: 0 }}
              animate={{ width: 'auto', opacity: 1 }}
              exit={{ width: 0, opacity: 0 }}
              transition={{ ease: 'easeInOut' }}
              style={itemStyle}
            >
              <FavoriteStar
                className="topbar-favorite-item-star"
                pair={pair}
                size={16}
              />
            </motion.div>
          ) : undefined}
        </AnimatePresence>
      </Item>
    </Reorder.Item>
  )
}

const itemStyle = {
  overflow: 'hidden',
}

const Item = styled.div<{ $isDrag: boolean }>`
  background: ${TOPBAR_BG_COLOR};
  border-radius: 2px;
  padding: 0 5px;
  position: relative;
  display: flex;
  align-items: center;

  cursor: ${(x) => (x.$isDrag ? 'grabbing' : 'auto')};

  & > * {
    pointer-events: ${(x) => (x.$isDrag ? 'none' : 'auto')};
  }
`
